const publicUrl = process.env.PUBLIC_URL || '';

export const introAssets = {
  hero: `${publicUrl}/luxspo/header-iphone.png`,
  ridingHero: `${publicUrl}/landing/marlta-hero-main.png`,
  appRider: `${publicUrl}/landing/marlta-app-rider.png`,
  partnerOffice: `${publicUrl}/landing/marlta-partner-office.png`,
  coverageMap: `${publicUrl}/landing/marlta-coverage-map.png`,
  ridingArena: `${publicUrl}/landing/equestrian-arena.jpg`,
  member: `${publicUrl}/luxspo/member-mockup.png`,
  management: `${publicUrl}/luxspo/icons/store-0001.png`,
  reservation: `${publicUrl}/luxspo/icons/store-0002.png`,
  record: `${publicUrl}/luxspo/icons/store-0003.png`,
  service: `${publicUrl}/luxspo/service-1.png`,
  blogIcon: `${publicUrl}/luxspo/icons/blog_logo.png`,
  youtubeIcon: `${publicUrl}/luxspo/icons/youtube_logo.png`,
  instagramIcon: `${publicUrl}/luxspo/icons/instagram_logo.png`,
  facebookIcon: `${publicUrl}/luxspo/icons/facebook_logo.png`,
  institutionGyeonggi: `${publicUrl}/luxspo/institutions/gyeonggi-creative-economy.jpg`,
  institutionMinistry: `${publicUrl}/luxspo/institutions/ministry-smes.png`,
  institutionKra: `${publicUrl}/luxspo/institutions/korea-racing-authority.jpeg`,
  institutionKsef: `${publicUrl}/luxspo/institutions/student-equestrian-federation.png`,
  institutionTherapeuticHorsemanship: `${publicUrl}/luxspo/institutions/therapeutic-horsemanship-association.png`,
  institutionKto: `${publicUrl}/luxspo/institutions/korea-tourism-organization.png`,
  institutionMafra: `${publicUrl}/luxspo/institutions/ministry-agriculture-food-rural-affairs.png`,
};
